import { render, staticRenderFns } from "./ServerQuickActions.vue?vue&type=template&id=1ce5c19c&scoped=true"
import script from "./ServerQuickActions.vue?vue&type=script&lang=js"
export * from "./ServerQuickActions.vue?vue&type=script&lang=js"
import style0 from "./ServerQuickActions.vue?vue&type=style&index=0&id=1ce5c19c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce5c19c",
  null
  
)

export default component.exports